var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookDesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.1735,
    r: 12,
    fill: "#5B78FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4251 24.1735V15.2581H8V12.0482H10.4251V9.30644C10.4251 7.15197 11.8577 5.17346 15.1585 5.17346C16.495 5.17346 17.4832 5.29801 17.4832 5.29801L17.4054 8.29556C17.4054 8.29556 16.3975 8.28602 15.2977 8.28602C14.1074 8.28602 13.9166 8.81926 13.9166 9.7043V12.0482H17.5L17.3441 15.2581H13.9166V24.1735H10.4251Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookDesk);
export default __webpack_public_path__ + "static/media/Facebook-desk.8323f57b.svg";
export { ForwardRef as ReactComponent };